import { render, staticRenderFns } from "./PenguinDetail.vue?vue&type=template&id=4f7c1e54&"
import script from "./PenguinDetail.vue?vue&type=script&lang=js&"
export * from "./PenguinDetail.vue?vue&type=script&lang=js&"
import style0 from "./PenguinDetail.vue?vue&type=style&index=0&id=4f7c1e54&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports